module.exports = __webpack_public_path__ + "static/quiz_bad-c870f41e6e06f20569b60061e9cceb54.jpg";